module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list-group-item"
  }, [_c('collapse', {
    attrs: {
      "selected": false,
      "id": 'fpv-' + _vm.fieldData.name
    }
  }, [_c('div', {
    staticClass: "collapsible-header",
    attrs: {
      "slot": "collapsible-header"
    },
    on: {
      "click": _vm.expand
    },
    slot: "collapsible-header"
  }, [_c('h4', [_vm._v(_vm._s(_vm.form ? _vm.form.name : ''))]), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('button', {
    staticClass: "btn default"
  }, [_vm._v(_vm._s(_vm.expanded ? 'Hide' : 'Show'))])])]), _vm._v(" "), _c('div', {
    staticClass: "collapsible-body",
    attrs: {
      "slot": "collapsible-body"
    },
    slot: "collapsible-body"
  }, [(_vm.form && _vm.form.hasOwnProperty('columns') && _vm.form.columns.length) ? _c('vue-good-table', {
    attrs: {
      "columns": _vm.form.columns,
      "rows": _vm.form.rows,
      "sort-options": {
        enabled: true
      },
      "globalSearch": false,
      "paginate": false,
      "styleClass": "table table-bordered show-all-results"
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.type === 'date') ? _c('span', [_vm._v(_vm._s(props.row[props.column.field]))]) : (props.column.field === '_date_created') ? _c('span', [_vm._v(_vm._s(_vm._f("formatDateModal")(props.row._date_created.date)))]) : (props.column.field === '_date_modified' && props.row._date_modified) ? _c('span', [_vm._v(_vm._s(_vm._f("formatDateModal")(props.row._date_modified.date)))]) : (props.column.field.startsWith('file-')) ? _c('span', _vm._l((_vm.formatFileValue(props.column.field, props.formattedRow[props.column.field])), function(file, index) {
          return _c('a', {
            key: ("file-" + index),
            attrs: {
              "href": file.url,
              "target": "_blank"
            }
          }, [(index !== 0) ? _c('span', [_vm._v(", ")]) : _vm._e(), _vm._v(_vm._s(file.name) + "\n            ")])
        }), 0) : _c('span', [_vm._v(_vm._s(props.formattedRow[props.column.field]))])]
      }
    }], null, false, 2457585799)
  }) : _vm._e()], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-69253896","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/formbuilder/SharedFieldFormPreview.vue
// module id = 1680
// module chunks = 1